export class MediaModel {
  constructor(
    public id: number = null,
    public codeMedia = '',
    public label = '',
    public description = '',
    public group: boolean = null,
    public isGroup: boolean = null,
    public groupMediaList: MediaModel[] = null
) {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
